import { useEffect, useState } from "react";
import Header from "../partials/header";
import LeftSidebar from "../partials/leftSidebar";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import GeneralCard from "../sharedComponent/generalCard";
import AuditLogIcon from "../../assets/images/audit-log.svg";
import UserIcon from "../../assets/images/users-icon.svg";
import { useNavigate } from "react-router-dom";
import { PROFILE_TYPE } from "../../helper/globalConstant";
import platformManagementIcon from "../../assets/images/platform.svg";

const AdminMain = () => {
  
  const cardData = [
    {
      name: "users",
      cardTitle: "Users",
      cardContent:
        "Manage all technician accounts under the Partner Account. Click here to add, edit, or remove accounts and configure permissions to ensure security and control.",
      image: UserIcon,
    },
    // {
    //   name: "auditTrail",
    //   cardTitle: "Audit Trail",
    //   cardContent:
    //     "Track and review all activity within your video management system. Click here to access detailed logs and ensure security and compliance.",
    //   image: AuditLogIcon,
    // },
  ];

  const cadminCardData = [
    {
      name: "partners",
      cardTitle: "Partners",
      cardContent:
        "Manage all Partner accounts under the Super Admin Account. Click here to add, edit, or remove accounts and configure permissions to ensure security and control.",
      image: UserIcon,
    },
    {
      name: "platform",
      cardTitle: "Platform Management",
      cardContent:
        "Setup your Platform for Public or Private Cloud.",
      image: platformManagementIcon,
    },
  ]

  const navigate = useNavigate();

  const [profileId, setProfileId] = useState<number | null>(null);

  useEffect(() => {
      const sess_user_data = localStorage.getItem("sess_user");

      if (sess_user_data != null) {
          try {
              const sess_user = JSON.parse(sess_user_data);
              const extractedProfileId = sess_user?.userProfile?.priority;
              const extractedName = sess_user?.user?.name;
              if (extractedProfileId) {
                  setProfileId(extractedProfileId);
              } else {
                  console.error("Profile ID not found in userProfile");
              }

          } catch (error) {
              console.error("Error parsing session user data:", error);
          }
      }
  }, []);

  const handleClick = (name:any)=>{
    if(name == "users"){
      navigate("/admin/users")
    }
    // if(name == "auditTrail"){
    //   navigate("/admin/audit-trail")
    // }
    if(name == "partners"){
      navigate("/admin/partner")
    }
    if(name == "platform")
      navigate("/admin/platform")

  }

  return (
    <Box sx={{ display: "flex" }}>
      <Header title="Admin"  />
      <LeftSidebar />
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: 8,
          padding: "0",
        }}
      >
        <Box sx={{ margin: "20px", height: "100vh" }} component="main">
          <Grid container spacing={2}>

            {profileId == PROFILE_TYPE.INTEGRATOR && 
            cardData.map((item: any) => (
              <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                <GeneralCard data={item} handleClick={handleClick} cardContainerStyle={{height: "167px" }} />
              </Grid>
            ))}
            {profileId == PROFILE_TYPE.SUPER_ADMIN && 
            cadminCardData.map((item: any) => (
              <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                <GeneralCard data={item} handleClick={handleClick} cardContainerStyle={{height: "167px" }} />
              </Grid>
            ))}
            
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminMain;
